interface ISupportMessageLocaleInfo {
    id: number;
    name: string;
}

const SUPPORT_MESSAGE_LOCALE_INFO: ISupportMessageLocaleInfo[] = [
    { id: 1, name: 'response-received'},
    { id: 2, name: 'awaiting-response' },
];

export default SUPPORT_MESSAGE_LOCALE_INFO;
